import InfoView from '../components/DataRuns/InfoView'
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import { StoreState } from '../types';

// 将 reducer 中的状态插入到组件的 props 中
const mapStateToProps = (state: StoreState) => ({
    data: state.data,
    api_id: state.api_id, // dummy
    api_id_list: state.api_id_list, 
    dataset_id: state.dataset_id,
    task_id: state.task_id,
    mode_id: state.mode_id,
    explore_meta_data: state.explore_meta_data,
    explore_refresh_number: state.explore_refresh_number,
    explore_loading: state.explore_loading
})

// 将 对应action 插入到组件的 props 中
const mapDispatchToProps = (dispatch: Dispatch) => ({
})

// 使用 connect 高阶组件对 Counter 进行包裹
export default connect(mapStateToProps, mapDispatchToProps)(InfoView);



